export default __webpack_public_path__ + "static/media/img03.becd1465.svg";